import { render, staticRenderFns } from "./tableLayout.vue?vue&type=template&id=23dc6fc6&"
import script from "./tableLayout.vue?vue&type=script&lang=js&"
export * from "./tableLayout.vue?vue&type=script&lang=js&"
import style0 from "./tableLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports